import authService from './authService';
import { readData, readList } from './apiResponse';
import type { Activity } from '../types/activity';
import type { Coverage, CoverageCreateRequest, CoveragePreviewRequest, CoverageRevertResult } from '../types/planning';

class CoverageService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /coverages */
  async getAll(): Promise<Coverage[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get('/coverages');
    return readList<Coverage>(response, 'Falha ao buscar as coberturas');
  }

  /** POST /coverages/preview → atividades que seriam repassadas */
  async preview(request: CoveragePreviewRequest): Promise<Activity[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.post('/coverages/preview', request);
    return readList<Activity>(response, 'Falha ao pré-visualizar a cobertura');
  }

  /** POST /coverages */
  async create(request: CoverageCreateRequest): Promise<Coverage> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.post('/coverages', request);
    return readData<Coverage>(response, 'Falha ao confirmar a cobertura');
  }

  /** POST /coverages/:id/revert */
  async revert(id: number): Promise<CoverageRevertResult> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.post(`/coverages/${id}/revert`);
    const data = await readData<CoverageRevertResult>(response, 'Falha ao reverter a cobertura');
    return { reverted: data?.reverted ?? 0, kept: data?.kept ?? 0 };
  }
}

export const coverageService = new CoverageService();
export default coverageService;
